export type LegacyTemplate = {
  bonusPoints?: number
  conversionDelayInHours?: number
  id: number | string
  messageContent?: string
  name: string
  notificationDelayInMinutes: number
  notificationSendingTime: string
  trigger: string
}
export type NewTemplate = {
  id: number | string
  name: string
  condition: boolean
}

export type TemplateItem = {
  id: number | string
  data: {
    triggerTemplate: string
    name: string
    status: string
    stores: string[]
    clicks: string
    revenue: string
    conversion: string
    messages: string
    isLegacy: boolean
  }
}

export const constructTemplates = ({
  templates,
  isLegacy
}: {
  templates: LegacyTemplate[] | NewTemplate[]
  isLegacy: boolean
}): TemplateItem[] => {
  return templates.map((template) => {
    return {
      id: template.id,
      data: {
        triggerTemplate: typeof template.id === 'number' ? template.trigger : template.id,
        name: template.name,
        status: 'inactive',
        stores: [],
        clicks: '-',
        revenue: '-',
        conversion: '-',
        messages: '-',
        isLegacy
      }
    }
  })
}
